import { render, staticRenderFns } from "./StatTickets.vue?vue&type=template&id=545ec848&"
import script from "./StatTickets.vue?vue&type=script&lang=js&"
export * from "./StatTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports